import { CheckCircle, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function HeroSection({ comparisonRef }) {
  const navigate = useNavigate();

  const benefits = [
    "Check loan rates and EMIs",
    "Compare loans and credit cards",
    "Explore credit score-based offers",
  ];

  const handleScrollToComparison = () => {
    if (comparisonRef.current) {
      comparisonRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="bg-gradient-to-b from-[#f9f4fb] to-white pt-10 md:pt-16 lg:pt-20 pb-2 md:pb-16 lg:pb-16">
      <div className="container px-3 md:px-6">
        <div className="mx-auto max-w-3xl">
          {/* Header */}
          <div className="text-center mb-3 md:mb-6">
            <h1 className="text-3xl font-bold leading-tight tracking-wide md:text-4xl lg:text-6xl mb-2 md:mb-4">
              Get Smart Loans with{" "}
              <span className="text-[#59266D]">Minimum EMIs</span>
            </h1>
            <p className="text-base text-gray-600 md:text-lg tracking-wide max-w-2xl mx-auto m-0">
              Choose from 20+ banks and get credit on your own terms.
            </p>
          </div>

          {/* Benefits */}
          <div className="mb-6 md:mb-8 flex justify-center">
            <div className="inline-flex flex-col space-y-2 text-left">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center">
                  <CheckCircle className="h-4 w-4 md:h-5 md:w-5 text-[#59266D] mr-2 flex-shrink-0" />
                  <span className="text-md md:text-base">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="mt-2 md:mt-0 flex flex-col space-y-2.5 sm:flex-row sm:space-y-0 sm:space-x-3 md:space-x-4 justify-center">
            <button
              type="button"
              onClick={() =>
                (window.location.href = "/personal-loan/check-eligibility")
              }
              className="text-sm h-11 md:text-base md:h-12 bg-[#59266D] hover:bg-[#59266D]/90 text-white rounded-full px-5 md:px-6 font-medium flex items-center justify-center transition-colors duration-200"
            >
              Check Eligibility
              <ArrowRight className="ml-2 h-4 w-4" />
            </button>

            <button
              type="button"
              onClick={handleScrollToComparison}
              className="text-sm h-11 md:text-base md:h-12 border-[1px] border-[#59266D] text-[#59266D] hover:bg-[#59266D]/10 rounded-full px-5 md:px-6 font-medium flex items-center justify-center transition-colors duration-200"
            >
              Compare Loans
            </button>
          </div>

          {/* Trust Indicator */}
          <div className="mt-4 md:mt-6 text-center">
            <p className="text-sm text-gray-500 md:text-sm tracking-wide m-0">
              Trusted by 50,000+ customers across India
            </p>
          </div>

          {/* Scroll Indicator for Mobile */}
          <div className="mt-2 flex justify-center md:hidden">
            <div
              className="w-10 h-10 rounded-full bg-white/80 flex items-center justify-center shadow-sm"
              onClick={() => {
                const scrollElement =
                  document.getElementById("empower_statement");
                if (scrollElement) {
                  scrollElement.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              <ArrowRight className="h-4 w-4  text-[#59266D]/70 transform rotate-90" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
